module.exports = __webpack_public_path__ + "static/media/disfraz-hombre.f0259fc9.jpg";